
import { createMuiTheme } from '@material-ui/core/styles';


export default createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    palette: {
        primary: {
          main: '#333333',
        },
        secondary: {
          main: '#2e7d32',
        },
      }
});


// WEBPACK FOOTER //
// ./src/Theme.js